export default __webpack_public_path__ + "files/78c11ca4715cf668702352178611bfaa.mp3";